import React from 'react';
import { ListDropdown } from '.';
import { IListDropdownProps } from './ListDropdown';

export interface ILaboratoryDropdownProps extends IListDropdownProps {
  placeholder?: string;
  maxResults?: number;
  restrictToCurrentUser?: boolean;
}

const LaboratoryDropdown: React.FC<ILaboratoryDropdownProps> = ({
  placeholder = 'Select laboratory...',
  /**
   * We would like to set this prop to something reasonable like "20", but it's broken.
   * @see https://spectraqest.atlassian.net/browse/QP-4701
   *
   * To see this problem, make `maxResults` a number like 2, and manually type in a lab that is cropped from the list on
   * the dry mass entry grid.
   */
  maxResults = 9999,
  restrictToCurrentUser = true, //** Denotes whether the list of laboratories is restricted to only those the current user has access to */
  ...otherProps
}) => {
  return (
    <ListDropdown
      {...otherProps}
      placeholder={placeholder}
      endpoint="list.laboratories"
      queryParams={{ limit: maxResults, restrictToCurrentUser }}
    />
  );
};

export { LaboratoryDropdown };
